// extracted by mini-css-extract-plugin
module.exports = {"summaryValue":"SummaryValue_summaryValue__30DZ1","bullet":"SummaryValue_bullet__3JMnJ"};